/**
 * Function returns JS date if property date is in valid format
 * otherwise returns null
 *
 * @propertyDateFormat 30.09-09:00
 *
 * @param-propertyDate String
 * @param-serverTime Date
 *
 * @returns Date or null
 * */
export const getDateFromProperty = (propertyDate, serverTime = new Date()) => {
  if (!/[0-9]{2}.[0-9]{2}-[0-9]{2}:[0-9]{2}/.test(propertyDate)) return null;
  const [date, time] = propertyDate.split('-');
  const [day, month] = date.split('.');
  const [hours, minutes] = time.split(':');
  const JSDate = serverTime;
  JSDate.setMonth(+month - 1);
  JSDate.setDate(+day);
  JSDate.setHours(+hours);
  JSDate.setMinutes(+minutes);
  JSDate.setSeconds(0);
  return JSDate;
};

/**
 * Function returns true if today is between two dates
 *
 * @param-from Date
 * @param-to Date
 * @param-serverTime Date
 *
 * @returns Boolean
 * */
export const isNowInRange = (from, to, serverTime = new Date()) => {
  const today = serverTime;
  return today > from && today < to;
};
